// Show the 2 tabs Your calculation; your answers.

import React, { useState, useEffect } from 'react';
import {
	Container,
	Header,
	Title,
	Text,
	Button,
	Icon,
	Footer,
	Left,
	Body,
	Right,
	ListItem,
	Content,
	Separator,
	View,
	Card,
	CardItem,
	H3,
	Tabs,
	Tab,
	Spinner,
	FooterTab,
	Label,
	Input,
	Form,
	Item
} from 'native-base';
import { Platform, Linking, WebView, StyleSheet, Dimensions } from 'react-native';
import { TextInput, ProgressBar, Colors } from 'react-native-paper';
import ShimmerPlaceHolder from 'react-native-shimmer-placeholder';
import Constants from 'expo-constants';

import CalCalDataApi from '../../api/CalCalDataApi';
import Pdf from '../../components/pdf';
import Alert from '../../components/alert';
//import { TabView, SceneMap } from 'react-native-tab-view';

export default function WhatSubmitted({ jwt, navigation, year, close, alreadySent }) {
	const { width, height } = Dimensions.get('window');
	const [error, setError] = useState(null);
	const [sa302, setSa302] = useState(null);
	const [ansHtml, setAnsHtml] = useState(null);
	const [ansPdf, setAnsPdf] = useState(null);

	useEffect(() => {
		//on first render, load answers and 302
		//wait - it could already have been sent
		if (alreadySent) {
			setSending(true);
			setWaiting(true);
			setSeconds(2);
			setPoll(10);
		} else if (!sending) {
			//this may fail on Edge due to redirect
			const edgeTime = setTimeout(
				() =>
					CalCalDataApi.dataLoad(`reports/SA302/${year}`, jwt, res => {
						if (__DEV__) console.log(res);

						if (!res.error) {
							setSa302({ html: res.html, pdf: res.content && 'data:application/pdf;base64,' + res.content });
						} else {
							setError(res.error);
						}
					}),
				12000
			);
			CalCalDataApi.dataLoad(`sa/${year}/302`, jwt, res => {
				if (__DEV__) console.log(res);
				clearTimeout(edgeTime);
				if (!res.error) {
					setSa302({ html: res.html, pdf: res.content && 'data:application/pdf;base64,' + res.content });
				} else {
					setError(res.error);
				}
			});
		}
	}, []);

	const changedTab = ({ i, ref, from }) => {
		if (i == 1 && !ansHtml) {
			CalCalDataApi.dataLoad(`sa/${year}/submitted`, jwt, res => {
				if (!res.error) {
					setAnsHtml(res.html);
					setAnsPdf(res.pdf);
				} else {
					setError(res.error);
				}
			});
		}
	};

	//countdown timer

	const [sending, setSending] = useState(false);
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');

	const [posting, setPosting] = useState(false);
	const [waiting, setWaiting] = useState(false);
	const [seconds, setSeconds] = useState(0);
	const [poll, setPoll] = useState(); //given poll time!

	const sendIt = () => {
		//may come back with errors...
		setPosting(true);
		CalCalDataApi.dataInsert(`sa/${year}`, { user: username, pass: password }, jwt, res => {
			setPosting(false);
			if (res.success) {
				const poll = parseInt(res.poll);
				if (poll > 0) {
					setPoll(res.poll);
					setSeconds(res.poll);
					setWaiting(true);
				}
			} else {
				if (!res.errors) return Alert('Error', 'Unspecified submission error');
				res.errors.forEach(e => Alert.alert(e.error_type ? 'Error in ' + e.error_type : 'Submisison error', e.error_msg || e));
			}
		});
	};

	const [pollResult, setPollResult] = useState();
	useEffect(() => {
		let interval = null;
		if (waiting) {
			if (seconds == 0) {
				setWaiting(false);
				//do poll check
				CalCalDataApi.dataLoad(`sa/poll/${year}`, jwt, res => {
					if (__DEV__) console.log(res);
					setPollResult(res);
					if (res.success) {
						Alert.alert('Submission accepted', res.nicemsg);
						//navigation.navigate('SaDetails/' + year);
					} else if (res.pollTime) {
						setPoll(res.pollTime);
						setPollResult(null);
						setSeconds(res.pollTime);
						setWaiting(true);
					} else {
						Alert.alert('Submission rejected', res.msg);
					}
				});
			} else {
				interval = setInterval(() => {
					setSeconds(seconds => seconds - 1);
					__DEV__ && console.log(seconds);
				}, 1000);
			}
		} else if (!waiting && seconds !== 0) {
			clearInterval(interval);
		}
		return () => clearInterval(interval);
	}, [waiting, seconds]);

	const closeAndRefresh = () => {
		//navigation.navigate('SaDetails', { year });
		//navigation.navigate('Report', { report: 'TaxForecast', url: 'TaxForecast', desc: 'Tax Forecast', rptFilter: false });
		navigation.goBack();
		close();
	};

	const [sentDiagnostics, setSentDiagnostics] = useState(false);
	const sendDiagnostics = () => {
		setSentDiagnostics(true);
		CalCalDataApi.dataLoad(`sa/diagnostics/${year}`, jwt, res => {
			if (__DEV__) console.log(res);
			if (res.success) {
				Alert.alert(
					'Diagnostics sent',
					'Your calculation will be reviewed confidentially by one of our team, and we will message you in the next 3 days with further information.\n\n Apologies for the inconvenience'
				);
			} else {
				Alert.alert('Diagnostics failed!', 'Please try again soon');
			}
		});
	};

	if (pollResult)
		return (
			<Container style={{ backgroundColor: '#FFF' }}>
				<Header style={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
					<Body>
						<Title>Submission {pollResult.success ? 'successful' : 'failed'}</Title>
					</Body>
				</Header>
				<Content padder>
					<H3>HMRC Says:</H3>
					<Text>{pollResult.nicemsg + '\n\n' + pollResult.msg + '\n'}</Text>
					{!pollResult.success ? (
						<>
							<Text note>
								Your return will be marked as error, which will allow you to send it again.{`\n`}If this is a calculation error, please use the button below to send diagnostics data to CalCal Support
							</Text>
							<Button onPress={sendDiagnostics} disabled={sentDiagnostics}>
								<Text>Send diagnostics</Text>
							</Button>
						</>
					) : (
						<Text note>You should shortly receive an email with your documents attached. You can also go to your tax summary page to download or print your calculation and submission.</Text>
					)}
				</Content>
				<Footer>
					<FooterTab>
						<Button disabled={posting || waiting} transparent onPress={closeAndRefresh}>
							<Text>Close</Text>
						</Button>
					</FooterTab>
				</Footer>
			</Container>
		);
	if (sending)
		return (
			<Container style={{ borderTopLeftRadius: 10, borderTopRightRadius: 10, backgroundColor: '#FFF' }}>
				<Header style={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
					<Body>
						<Title>Send your return</Title>
					</Body>
				</Header>
				{waiting ? (
					<Content padder>
						<Text>Waiting for HMRC...</Text>
						<View padder />
						<ProgressBar progress={(poll - seconds) / poll} />
					</Content>
				) : (
					<Content padder>
						<Text>To confirm your answers and submit to HMRC, please enter your Government Gateway details</Text>
						<Text note>Note: You need "Sign in with Government Gateway" ID not GOV.UK Verify</Text>
						<View padder />
						<TextInput label="Username" value={username} onChangeText={setUsername} />
						<TextInput label="Password" secureTextEntry value={password} onChangeText={setPassword} />
					</Content>
				)}
				<Footer>
					<FooterTab>
						<Button disabled={posting || waiting} transparent onPress={() => setSending(false)}>
							<Text>Cancel</Text>
						</Button>
					</FooterTab>
					<Button disabled={posting || waiting} onPress={sendIt}>
						<Text>Confirm & Submit</Text>
					</Button>
				</Footer>
			</Container>
		);
	/*
	const calcView = () => (
		<View>
			{!sa302 && (
				<View>
					<Spinner />
					<Text>Calculating...</Text>
				</View>
			)}
			{sa302 && <Pdf htmlContent={sa302.html} pdfContent={sa302.pdf} />}
		</View>
	);

	const ansView = () => (
		<View>
			{!ansHtml && (
				<>
					<Spinner />
					<Text>Retrieving your answers...</Text>
				</>
			)}
			{ansHtml && <Pdf htmlContent={ansHtml} pdfContent={null} />}
		</View>
	);

	const routes = [
		{ key: 'calc', title: 'Calculation' },
		{ key: 'ans', title: 'Your answers' }
	];
	const [index, setIndex] = useState(0);
	return (
		<TabView
			navigationState={{ index, routes }}
			onIndexChange={setIndex}
			initialLayout={{ width: '100%', height: '100%' }}
			renderScene={SceneMap({
				calc: calcView,
				ans: ansView
			})}
		/>
    );*/

	const tabHeight = height - 95;
	return (
		<>
			<Tabs locked onChangeTab={changedTab}>
				<Tab heading="Calculation" style={{ height: tabHeight }}>
					{!!error &&
						(error == 'subscription' ? (
							<View padder>
								<H3>Payment required</H3>
								<Text>You need to purchase the tax return to see your detailed calculation</Text>
								<Button
									primary
									onPress={() => {
										navigation.navigate('SubscriptionContainer');
										close();
									}}>
									<Text>Buy now</Text>
								</Button>
							</View>
						) : (
							<Text>{error}</Text>
						))}
					{!error && !sa302 && (
						<View style={{ flex: 1, alignItems: 'center' }}>
							<Spinner />
							<Text>Calculating...</Text>
						</View>
					)}
					{sa302 && <Pdf htmlContent={sa302.html} pdfContent={sa302.pdf} height={tabHeight} showDownload />}
				</Tab>

				<Tab heading="Your return" style={{ height: tabHeight }}>
					{!ansPdf && (
						<View style={{ flex: 1, alignItems: 'center' }}>
							<Spinner />
							<Text>Retrieving your answers...</Text>
						</View>
					)}
					{ansPdf && <Pdf pdfContent={ansPdf && 'data:application/pdf;base64,' + ansPdf} height={tabHeight} showDownload />}
				</Tab>
			</Tabs>

			<Footer>
				<FooterTab>
					<Button disabled={!sa302} primary onPress={() => setSending(true)}>
						<Text>Send</Text>
					</Button>
				</FooterTab>
				<FooterTab>
					<Button onPress={close}>
						<Text>Close</Text>
					</Button>
				</FooterTab>
			</Footer>
		</>
	);
}
